import React from "react";
import "../styles/styles.css";

const Footer: React.FC = () => {
  return (
    <footer className="App-footer">
      <p>&copy; 2024 Scissor. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
